class ExpandedCollectionFilters extends HTMLElement {
  constructor() {
    super();
    this.activeGroup = null;
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
  }

  connectedCallback() {
    if (!this.isDesktop()) return;

    this.groups = [...this.querySelectorAll("[data-expanded-filter-group]")];
    this.bindTriggers();
    this.bindSwatchToggles();
    document.addEventListener("click", this.onDocumentClick);
    document.addEventListener("keydown", this.onKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.onDocumentClick);
    document.removeEventListener("keydown", this.onKeydown);
  }

  isDesktop() {
    return window.innerWidth >= 1280;
  }

  bindTriggers() {
    this.groups.forEach((group) => {
      const trigger = group.querySelector("[data-expanded-filter-trigger]");
      const panel = group.querySelector("[data-expanded-filter-panel]");
      if (!trigger || !panel) return;

      trigger.addEventListener("click", (event) => {
        event.stopPropagation();
        const isOpen = group.classList.contains("is-open");
        this.closeAll();
        if (!isOpen) this.openGroup(group);
      });
    });
  }

  bindSwatchToggles() {
    this.querySelectorAll("[data-expanded-swatches-toggle]").forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();

        const panel = button.closest("[data-expanded-filter-panel]");
        const swatches = panel?.querySelector(".m-expanded-filters__options--swatches");
        if (!swatches) return;

        const isCollapsed = swatches.classList.toggle("is-collapsed");
        const text = button.querySelector("[data-more-text]");
        if (text) text.textContent = isCollapsed ? "More..." : "Less";
      });
    });
  }

  openGroup(group) {
    const trigger = group.querySelector("[data-expanded-filter-trigger]");
    const panel = group.querySelector("[data-expanded-filter-panel]");
    if (!trigger || !panel) return;

    group.classList.add("is-open");
    trigger.setAttribute("aria-expanded", "true");
    panel.hidden = false;
    this.activeGroup = group;
  }

  closeAll() {
    this.groups.forEach((group) => {
      const trigger = group.querySelector("[data-expanded-filter-trigger]");
      const panel = group.querySelector("[data-expanded-filter-panel]");
      group.classList.remove("is-open");
      if (trigger) trigger.setAttribute("aria-expanded", "false");
      if (panel) panel.hidden = true;
    });
    this.activeGroup = null;
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) this.closeAll();
  }

  onKeydown(event) {
    if (event.key === "Escape") this.closeAll();
  }
}

if (!customElements.get("expanded-collection-filters")) {
  customElements.define("expanded-collection-filters", ExpandedCollectionFilters);
}
